import * as Yup from 'yup';

export const PerfilEsquema = Yup.object().shape({
    nome: Yup.string().required('Campo obrigatório'),
});
